module.exports = __webpack_public_path__ + "img/card-fail.2e65d035.svg";